import { createSlice } from '@reduxjs/toolkit';

type IData = {
  pin: string;
  surname: string;
  name: string;
  patronym: string;
  gender: string;
  date_of_birth: string;
  experience: ExperianceType[];
};

type ExperianceType = {
  action_type_id: number;
  company_inn: string;
  company_name: string;
  contract_date: string;
  contract_number: string;
  end_date: string;
  kodp: string;
  kodp_type: string;
  order_date: null;
  order_number: null;
  parent_id: number;
  person_pin: string;
  position_id: number;
  position_name: string;
  soato_code: string;
  start_date: string;
  structure_name: string;
  transaction_id: number;
  work_type: number;
  workplace_address: string;
};

type RequestCommandState = {
  loading: boolean;
  data: IData;
};

let data;

const initialState: RequestCommandState = {
  loading: false,
  data,
};

export const workHistorySlice = createSlice({
  name: 'integrationsWorkHistory',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export default workHistorySlice.reducer;
